module.exports = __webpack_public_path__ + "static/FlutterQRReader-d2210fd4fcecfc90ab92f8230e7b6433.jpg";